// extracted by mini-css-extract-plugin
export default {"colorBrand":"#254a91","colorWhite":"#fff","colorBlueBright":"#81a9f2","accordion":"accordion_qeKcT","rowInHeader":"rowInHeader_e4Nrp"};